import styled from 'styled-components';

export const Center = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center; 
`;
